/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DateRange } from './DateRange';
import {
    DateRangeFromJSON,
    DateRangeFromJSONTyped,
    DateRangeToJSON,
    DateRangeToJSONTyped,
} from './DateRange';
import type { Address } from './Address';
import {
    AddressFromJSON,
    AddressFromJSONTyped,
    AddressToJSON,
    AddressToJSONTyped,
} from './Address';
import type { RelatedEntity } from './RelatedEntity';
import {
    RelatedEntityFromJSON,
    RelatedEntityFromJSONTyped,
    RelatedEntityToJSON,
    RelatedEntityToJSONTyped,
} from './RelatedEntity';
import type { AdditionalIdentification } from './AdditionalIdentification';
import {
    AdditionalIdentificationFromJSON,
    AdditionalIdentificationFromJSONTyped,
    AdditionalIdentificationToJSON,
    AdditionalIdentificationToJSONTyped,
} from './AdditionalIdentification';
import type { Contact } from './Contact';
import {
    ContactFromJSON,
    ContactFromJSONTyped,
    ContactToJSON,
    ContactToJSONTyped,
} from './Contact';

/**
 * 
 * @export
 * @interface PharmacySection
 */
export interface PharmacySection {
    /**
     * 
     */
    date_range?: DateRange;
    /**
     * 
     */
    organization_name?: string;
    /**
     * 
     */
    contract_number?: string;
    /**
     * 
     */
    plan_number?: string;
    /**
     * 
     */
    plan_name?: string;
    /**
     * 
     */
    plan_description?: string;
    /**
     * 
     */
    contacts?: Array<Contact>;
    /**
     * 
     */
    address?: Address;
    /**
     * 
     */
    additional_identifications?: Array<AdditionalIdentification>;
    /**
     * 
     */
    related_entities?: Array<RelatedEntity>;
}

/**
 * Check if a given object implements the PharmacySection interface.
 */
export function instanceOfPharmacySection(value: object): value is PharmacySection {
    return true;
}

export function PharmacySectionFromJSON(json: any): PharmacySection {
    return PharmacySectionFromJSONTyped(json, false);
}

export function PharmacySectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): PharmacySection {
    if (json == null) {
        return json;
    }
    return {
        
        'date_range': json['date_range'] == null ? undefined : DateRangeFromJSON(json['date_range']),
        'organization_name': json['organization_name'] == null ? undefined : json['organization_name'],
        'contract_number': json['contract_number'] == null ? undefined : json['contract_number'],
        'plan_number': json['plan_number'] == null ? undefined : json['plan_number'],
        'plan_name': json['plan_name'] == null ? undefined : json['plan_name'],
        'plan_description': json['plan_description'] == null ? undefined : json['plan_description'],
        'contacts': json['contacts'] == null ? undefined : ((json['contacts'] as Array<any>).map(ContactFromJSON)),
        'address': json['address'] == null ? undefined : AddressFromJSON(json['address']),
        'additional_identifications': json['additional_identifications'] == null ? undefined : ((json['additional_identifications'] as Array<any>).map(AdditionalIdentificationFromJSON)),
        'related_entities': json['related_entities'] == null ? undefined : ((json['related_entities'] as Array<any>).map(RelatedEntityFromJSON)),
    };
}

export function PharmacySectionToJSON(json: any): PharmacySection {
    return PharmacySectionToJSONTyped(json, false);
}

export function PharmacySectionToJSONTyped(value?: PharmacySection | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'date_range': DateRangeToJSON(value['date_range']),
        'organization_name': value['organization_name'],
        'contract_number': value['contract_number'],
        'plan_number': value['plan_number'],
        'plan_name': value['plan_name'],
        'plan_description': value['plan_description'],
        'contacts': value['contacts'] == null ? undefined : ((value['contacts'] as Array<any>).map(ContactToJSON)),
        'address': AddressToJSON(value['address']),
        'additional_identifications': value['additional_identifications'] == null ? undefined : ((value['additional_identifications'] as Array<any>).map(AdditionalIdentificationToJSON)),
        'related_entities': value['related_entities'] == null ? undefined : ((value['related_entities'] as Array<any>).map(RelatedEntityToJSON)),
    };
}

